module.exports = __webpack_public_path__ + "static/media/feature-lightning.b8b9e586.svg";